export default {
  modelName: 'Dodone',
  attributes: {
    ancestry: {
      name: "ancestry",
      apiName: "ancestry",
      camelName: "ancestry",
      underscoreName: "ancestry",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Ancestry",
    },
    comment: {
      name: "comment",
      apiName: "comment",
      camelName: "comment",
      underscoreName: "comment",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Comment",
    },
    createdAt: {
      name: "createdAt",
      apiName: "created_at",
      camelName: "createdAt",
      underscoreName: "created_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Created At",
    },
    currentAt: {
      name: "currentAt",
      apiName: "current_at",
      camelName: "currentAt",
      underscoreName: "current_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Current At",
    },
    day: {
      name: "day",
      apiName: "day",
      camelName: "day",
      underscoreName: "day",
      type: "date",
      writeable: true,
      default: null,
      humanName: "Day",
    },
    dodoable: {
      name: "dodoable",
      apiName: "dodoable",
      camelName: "dodoable",
      underscoreName: "dodoable",
      type: "belongs_to",
      writeable: true,
      default: null,
      humanName: "Dodoable",
      model: "Dodoable",
    },
    dodoableId: {
      name: "dodoableId",
      apiName: "dodoable_id",
      camelName: "dodoableId",
      underscoreName: "dodoable_id",
      type: "integer",
      writeable: true,
      default: null,
      humanName: "Dodoable",
    },
    finishedAt: {
      name: "finishedAt",
      apiName: "finished_at",
      camelName: "finishedAt",
      underscoreName: "finished_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Finished At",
    },
    id: {
      name: "id",
      apiName: "id",
      camelName: "id",
      underscoreName: "id",
      type: "integer",
      writeable: false,
      default: null,
      humanName: "Id",
    },
    isFinished: {
      name: "isFinished",
      apiName: "finished?",
      camelName: "isFinished",
      underscoreName: "is_finished",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Finished",
    },
    isNotFinished: {
      name: "isNotFinished",
      apiName: "not_finished?",
      camelName: "isNotFinished",
      underscoreName: "is_not_finished",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Not Finished",
    },
    isNotStarted: {
      name: "isNotStarted",
      apiName: "not_started?",
      camelName: "isNotStarted",
      underscoreName: "is_not_started",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Not Started",
    },
    isStarted: {
      name: "isStarted",
      apiName: "started?",
      camelName: "isStarted",
      underscoreName: "is_started",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Started",
    },
    log: {
      name: "log",
      apiName: "log",
      camelName: "log",
      underscoreName: "log",
      type: "jsonb",
      writeable: true,
      default: "{}",
      humanName: "Log",
    },
    order: {
      name: "order",
      apiName: "order",
      camelName: "order",
      underscoreName: "order",
      type: "integer",
      writeable: true,
      default: 0,
      humanName: "Order",
    },
    settings: {
      name: "settings",
      apiName: "settings",
      camelName: "settings",
      underscoreName: "settings",
      type: "jsonb",
      writeable: true,
      default: "{}",
      humanName: "Settings",
    },
    startedAt: {
      name: "startedAt",
      apiName: "started_at",
      camelName: "startedAt",
      underscoreName: "started_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Started At",
    },
    status: {
      name: "status",
      apiName: "status",
      camelName: "status",
      underscoreName: "status",
      type: "string",
      writeable: true,
      default: "pending",
      humanName: "Status",
    },
    updatedAt: {
      name: "updatedAt",
      apiName: "updated_at",
      camelName: "updatedAt",
      underscoreName: "updated_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Updated At",
    },
    user: {
      name: "user",
      apiName: "user",
      camelName: "user",
      underscoreName: "user",
      type: "belongs_to",
      writeable: true,
      default: null,
      humanName: "User",
      model: "User",
    },
    userId: {
      name: "userId",
      apiName: "user_id",
      camelName: "userId",
      underscoreName: "user_id",
      type: "integer",
      writeable: true,
      default: null,
      humanName: "User",
    },
  },
  names: {
    singularUnderscore: "dodone",
    pluralUnderscore: "dodones",
    singularDash: "dodone",
    pluralDash: "dodones",
    singularCamel: "dodone",
    pluralCamel: "dodones",
    singularClass: "Dodone",
    pluralClass: "Dodones",
    human: "Dodone",
  },
  validators: [
    {
      className: "ActiveModel::Validations::FormatValidator",
      options: {
        allowNil: true,
        with: null,
      },
      attributes: [
        "ancestry",
      ],
    },
    {
      className: "ActiveRecord::Validations::PresenceValidator",
      options: {
        message: "required",
        if: null,
      },
      attributes: [
        "user",
      ],
    },
    {
      className: "ActiveRecord::Validations::PresenceValidator",
      options: {
        message: "required",
        if: null,
      },
      attributes: [
        "dodoable",
      ],
    },
  ],
  enums: {
    status: {
      name: "status",
      valueMap: {
        pending: 0,
        ongoing: 1,
        completed: 2,
        ignored: 3,
      },
      options: {
        pending: 0,
        ongoing: 1,
        completed: 2,
        ignored: 3,
      },
    },
  },
}
